import {API_PROJECT, API_PROJECT_LEADS} from '../../const/Api';
import {RestApiMethod} from '../../const/dataEnum';
import {callAPI} from './callApi';

const getAll = async () => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_PROJECT,
    });
    return res.data.data;
  } catch (error) {
    return null;
  }
};

const getProjectLeads = async () => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_PROJECT_LEADS,
    });
    return res.data;
  } catch (error) {
    return null;
  }
};

const projectApi = {
  getAll,
  getProjectLeads,
};

export default projectApi;
